import { createClient } from '@supabase/supabase-js'

const supabaseUrl = "https://cdxlbduhgrtbvnmqzice.supabase.co"
const supabaseAnonKey = "sb_publishable_bMiQub-iJiP7b8EpZCkRGw_VZByWYVN"

export const supabase = createClient(supabaseUrl, supabaseAnonKey)
